<template>
    <div class="pagina page-index d-flex flex-column justify-content-between">

        <AppHeader/>

        <main>
            <div class="container">
                <div class="row">

                    <!-- Titulos y año -->
                    <div class="col-lg-8 d-flex flex-column justify-content-center mb-2">
                        <h1 class="h1-index">{{ aplica.titulo }}</h1>
                        <h2 class="h2-index">{{ aplica.subtitulo }}</h2>
                        <h2 class="h2-index">{{ aplica.subtitulo2 }}</h2>
                        <span class="year">{{ aplica.year }}</span>
                    </div>

                    <!-- Login / Acceso -->
                    <div class="col-lg-4">
                        <div class="card-login p-5">
                            <h3 class="mb-3">Acceso</h3>

                            <b-form>
                                <b-form-group class="pt-2"
                                    label="Usuario / Agencia" label-for="user"
                                    v-bind="attr_user">
                                    <b-input-group class="my-2">
                                        <b-form-input type="text" id="user" ref="user"
                                            v-model="user.user" trim
                                            v-bind="attr_user">
                                        </b-form-input>
                                        <!-- <b-input-group-prepend is-text><b-icon-person-fill/></b-input-group-prepend>                    -->
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group
                                    label="Contraseña / Password" label-for="pass">
                                    <b-input-group class="my-2">
                                        <b-form-input type="password" id="pass" ref="pass"
                                            v-model="user.pass"
                                            v-bind="attr_pass"
                                            @keypress.13="check">
                                        </b-form-input>
                                        <!-- <b-input-group-prepend is-text><b-icon-eye @click="alert('aa')"/></b-input-group-prepend> -->
                                    </b-input-group>
                                </b-form-group>

                                <div class="text-center">
                                    <p class="mt-3">
                                        <a href="#" class="mr-2" @click="olvidar">¿Olvidó su contraseña?</a>
                                    </p>
                                    <button type="button" class="btn btn-primary"
                                        data-toggle="modal" data-target="#response"
                                        @click.prevent="check">
                                        Acceso
                                    </button>
                                </div>
                                <div class="text-center mt-2">
                                    <small style="color: #0b4f6c;">v{{ version }}</small>
                                </div>
                            </b-form>
                        </div>
                    </div>
                </div>
            </div>
        </main>

        <AppFooter/>

    </div>
</template>

<script>

import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  name: 'home',
  components: { //login,
    AppHeader,
    AppFooter,
  },
  data() {
    return {
        cierre: false,

        user: { user:'', pass:'', error: '', logU: false, logP: false, sid: '' },
        //error: { error: false, msg: '', title:'' },
    }
  },

  created() {
    if (this.cierre) { this.cerrado(); return; }

    // si recargamos y estamos logueados nos vamos a reserva
    if (this.logueado) {
      if (this.$route.name=='home')
        this.$router.push('/reserva');
      //else
      //  this.$bvModal.hide("modal_login");
    }

    this.year=new Date().getFullYear();
  },

  computed: {
    ...mapState(['auth','aplica','errores']),

    logueado() {
      return this.auth.logueado;
    },
    usuario() {
        return this.$store.state.auth.user;
    },
    version() {
        return process.env.VUE_APP_VERSION;
    },

    // atributos usuario / acceso
    attr_user() {
      //if (this.user.logU) return {state: true, disabled: false, "valid-feedback": "USUARIO REGISTRADO" };
      //if (this.user.error) return {state: false, disabled: false, "invalid-feedback": this.user.error };
      return { disabled: false};
    },
    attr_pass() {
      return { disabled: false};
    },
    // texto boton
    btn_login() {
      return "ACCESO"; //(!this.user.logU ? "CONTINUAR" : "CONECTARSE");
    }

  },

  methods: {
    ...mapMutations(['loading','alerta','modal']),
    ...mapActions(['exec','error']),

    cerrado() {
        let msg="Estamos elaborando los Programas de Vacaciones para la próxima temporada.<br><br><u>Por favor, vuelve a visitarnos un poco más adelante.";
        this.modal({tit:"Información", msg});
    },

    olvidar() {
      let msg="Debe contactar con nosotros en el Teléfono: <br><b><h4>950 627 019</h4></b>";
      this.modal({tit:'ACCESO', msg});
    },

    async check() {
      if (this.cierre) { this.cerrado(); return; }

      let user=this.user.user;
      let pass=this.user.pass;
      let token=this.auth.token;

      if (user=='') this.modal({tit:'ACCESO', msg:"Debes Introducir Usuario"});
      if (pass=='') this.modal({tit:'ACCESO', msg:"Debes Introducir Contraseña"});

      let arg={user, pass, token };
      await this.login(arg);
    },

    async login(arg) {
      this.loading();
      let r=await this.exec({api:'login', arg});
      this.loading(false);

      await this.login_back(r);
    },

    async login_back(r) {
      this.user.error="";
      ////////////////////////////////////////////// si error
      if (await this.error({r, tit:'ACCESO'})) {
        this.$refs.pass.focus();
        return;
      }

      await this.$store.commit('login_back',r);
      console.log('*login_back->lb',this.$router)

      if (this.$router.name!='/reserva') this.$router.push('/reserva');
    },

  },

}
</script>
